import { createAction, props } from '@ngrx/store';
import { PartnersEntity } from '../models/partners.models';

//-- Partners
export const loadPartners = createAction(
  '[SkyMiles Partners/PE] Partners Init'
);

export const loadPartnersDataSuccess = createAction(
  '[SkyMiles Partners/PE] Load Partners Success',
  props<{ partners: PartnersEntity }>()
);

export const loadPartnersDataFailure = createAction(
  '[SkyMiles Partners/PE] Load Partners Failure',
  props<{ error: PartnersEntity }>()
);

//-- Partners Promotions
export const loadPartnersPromotions = createAction(
  '[SkyMiles PartnersPromotions/API] Partners Promotions Init'
);

export const loadPartnersPromotionsDataSuccess = createAction(
  '[SkyMiles PartnersPromotions/API] Load Partners Promotions Success',
  props<{ partnersPromotions: PartnersEntity }>()
);

export const loadPartnersPromotionsDataFailure = createAction(
  '[SkyMiles PartnersPromotions/API] Load Partners Promotions Failure',
  props<{ error: PartnersEntity }>()
);

//-- AEM Error Messages
export const loadAEMErrorMessages = createAction(
  '[SkyMiles PartnersPromotions/API] Load AEM Error Messages'
);

export const loadAEMErrorMessagesSuccess = createAction(
  '[SkyMiles PartnersPromotions/API] Load AEM Error Messages Success',
  props<{ aemErrorMessages: PartnersEntity }>()
);

export const loadAEMErrorMessagesFailure = createAction(
  '[SkyMiles PartnersPromotions/API] Load AEM Error Messages Failure',
  props<{ aemErrorMessagesError: PartnersEntity }>()
);
